import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=174c3e67&scoped=true&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&id=174c3e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174c3e67",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Preloader: require('/home/bitrix/frontend/components/other/Preloader.vue').default,CreateBtn: require('/home/bitrix/frontend/components/gallery/personal/CreateBtn.vue').default,ProfileAvatar: require('/home/bitrix/frontend/components/profile/ProfileAvatar.vue').default,ProfileMenu: require('/home/bitrix/frontend/components/profile/ProfileMenu.vue').default,SidebarAnchors: require('/home/bitrix/frontend/components/other/SidebarAnchors.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,LeftAside: require('/home/bitrix/frontend/components/other/LeftAside.vue').default,ProfileGallery: require('/home/bitrix/frontend/components/profile/ProfileGallery.vue').default})
